export default __webpack_public_path__ + "static/media/43.796da91c.png";